import toast from 'react-hot-toast';
import { UpdateType } from 'src/constants/portfolio';

import defaultGuard from '@savvy/utils/default-guard';

export function addHiddenItemsToNetWorth(
  netWorth: string,
  portfolioItemGroups?: { hiddenFromClientTotalValue: { amount: string } }[],
) {
  let finalNetWorth = Number(netWorth);
  (portfolioItemGroups || []).forEach((group) => {
    finalNetWorth += Number(group.hiddenFromClientTotalValue.amount);
  });
  return finalNetWorth;
}

export function showMessageBeforeRefetch(type: UpdateType) {
  switch (type) {
    case UpdateType.UPDATE_ACCOUNT:
    case UpdateType.UPDATE_PROVIDER_ACCOUNT:
    case UpdateType.UPDATE_ASSET:
    case UpdateType.UPDATE_LIABILITY:
    case UpdateType.UPDATE_COMPANY_EQUITY:
    case UpdateType.UPDATE_REAL_ESTATE:
      return true;
    case UpdateType.CREATE_PROVIDER_ACCOUNT:
    case UpdateType.DELETE_PROVIDER_ACCOUNT:
    case UpdateType.CREATE_ACCOUNT:
    case UpdateType.DELETE_ACCOUNT:
    case UpdateType.CREATE_ASSET:
    case UpdateType.DELETE_ASSET:
    case UpdateType.CREATE_COMPANY_EQUITY:
    case UpdateType.DELETE_COMPANY_EQUITY:
    case UpdateType.CREATE_REAL_ESTATE:
    case UpdateType.DELETE_REAL_ESTATE:
    case UpdateType.CREATE_LIABILITY:
    case UpdateType.DELETE_LIABILITY:
    case UpdateType.REFRESH_PROVIDER_ACCOUNT:
    case UpdateType.SHOW_HIDE_NET_WORTH:
  }
  return false;
}

export function updateToast(type: UpdateType) {
  let message;
  switch (type) {
    case UpdateType.CREATE_ACCOUNT:
    case UpdateType.CREATE_PROVIDER_ACCOUNT:
      message = 'Account added';
      break;
    case UpdateType.CREATE_ASSET:
      message = 'Asset added';
      break;
    case UpdateType.CREATE_LIABILITY:
      message = 'Liability added';
      break;
    case UpdateType.CREATE_COMPANY_EQUITY:
      message = 'Company equity added';
      break;
    case UpdateType.CREATE_REAL_ESTATE:
      message = 'Real estate added';
      break;
    case UpdateType.UPDATE_ACCOUNT:
      message = 'Account updated';
      break;
    case UpdateType.UPDATE_PROVIDER_ACCOUNT:
      message = 'Account(s) reconnected';
      break;
    case UpdateType.UPDATE_ASSET:
      message = 'Asset updated';
      break;
    case UpdateType.UPDATE_LIABILITY:
      message = 'Liability updated';
      break;
    case UpdateType.UPDATE_COMPANY_EQUITY:
      message = 'Company equity updated';
      break;
    case UpdateType.UPDATE_REAL_ESTATE:
      message = 'Real estate updated';
      break;
    case UpdateType.DELETE_ACCOUNT:
    case UpdateType.DELETE_PROVIDER_ACCOUNT:
      message = 'Account deleted';
      break;
    case UpdateType.DELETE_ASSET:
      message = 'Asset deleted';
      break;
    case UpdateType.DELETE_LIABILITY:
      message = 'Liability deleted';
      break;
    case UpdateType.DELETE_COMPANY_EQUITY:
      message = 'Company equity deleted';
      break;
    case UpdateType.DELETE_REAL_ESTATE:
      message = 'Real estate deleted';
      break;
    case UpdateType.REFRESH_PROVIDER_ACCOUNT:
    case UpdateType.SHOW_HIDE_NET_WORTH:
      break;
  }

  if (message) {
    toast.success(message);
  }
}

export type PortfolioToggleTab = 'accounts' | 'assetClasses' | 'holdings' | 'transactions';

export function portfolioToggleTabName(tab: PortfolioToggleTab) {
  switch (tab) {
    case 'assetClasses':
      return 'Asset classes';
    case 'holdings':
      return 'Holdings';
    case 'accounts':
      return 'Accounts';
    case 'transactions':
      return 'Transactions';
    default:
      return defaultGuard(tab, tab);
  }
}
